import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { fromEvent, Observable, Subject } from 'rxjs';
import { SettingsDataStore } from '../../../../settings-data/settings-data.store';
import { NavigationService, WindowRefService } from 'i2g-ng-utils';
import { filter, map, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-paypal-onboarding-dialog',
  templateUrl: './paypal-onboarding-dialog.component.html',
  styleUrls: ['./paypal-onboarding-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PayPalOnboardingDialogComponent implements OnInit, OnDestroy {
  private _destroyed: Subject<boolean> = new Subject<boolean>();

  webviewUrl$: Observable<string>;

  constructor(
    private _settingsDataStore: SettingsDataStore,
    private _windowRefService: WindowRefService,
    private _navigationService: NavigationService
  ) {}

  ngOnInit() {
    this.webviewUrl$ = this._settingsDataStore.getPayPalOnboardingUrl();

    fromEvent(this._windowRefService.nativeWindow, 'message')
      .pipe(
        filter((e: MessageEvent) => !!e?.data),
        map((e: MessageEvent) => e.data),
        takeUntil(this._destroyed)
      )
      .subscribe((data) => {
        try {
          const message = JSON.parse(data);

          if (message?.action == 'redirect' && message.url) {
            this._navigationService.goToExternalUrl(message.url);
          }
        } catch {
          // ignore error
        }
      });
  }

  ngOnDestroy() {
    this._destroyed.next(true);
    this._destroyed.unsubscribe();
  }
}
